import { render, staticRenderFns } from "./jobworklotreceiptview.vue?vue&type=template&id=8b310694&scoped=true"
import script from "./jobworklotreceiptview.vue?vue&type=script&lang=js"
export * from "./jobworklotreceiptview.vue?vue&type=script&lang=js"
import style0 from "./jobworklotreceiptview.vue?vue&type=style&index=0&id=8b310694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b310694",
  null
  
)

export default component.exports